import {Dropdown, Input} from "semantic-ui-react";
import React from "react";
import '../LabelInput/LabelInput.css'
import '../LabelButtonsInput/LabelButtonsInput.css'

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/26/19
 * Time: 9:34 AM
 */
const App = (props) => (
  <Input
    input={<input onClick={props.inputClick} type={props.type} value={props.value} onChange={props.onChange}
                  disabled={props.disable} className={props.inputClass}/>}
    style={{width: '100%', marginBottom: '12px', height: '40px'}}
    label={<label style={{width: props.lblWidth ? props.lblWidth : '110px', fontSize: props.lblFontSize}}
                  className={`ui label ${props.lblClassname}`}>
      {props.tagText}
      {
        props.required ?
          <span className={"required-field-input"}>*</span>
          : null
      }

    </label>}
    labelPosition='left'
    placeholder={props.placeholder}
    onChange={props.onChange}
    action={<Dropdown style={{width: 'auto!important'}} onChange={props.onDropdownChange}
                      button basic floating
                      options={props.options}
                      value={props.dropdownValue} className={"end-"}/>}
  />
);

export default App
